
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea868"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea868"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6uXpe", function(module, exports) {

$parcel$export(module.exports, "P", function () { return $4bb3a0349e9e11f5$export$56c0d5a1e737357d; });
// Telia colour palette - referenced as P.<name> in copy.js and across the presentation.
const $4bb3a0349e9e11f5$export$56c0d5a1e737357d = {
    // Telia base
    deep: "#29003E",
    dark: "#3D1556",
    card: "#4A1969",
    purple: "#990AE3",
    light: "#F4E0FF",
    magenta: "#C23FE3",
    teal: "#00827C",
    // Futuristic accents
    cyan: "#00D4FF",
    electric: "#7DD3FC",
    gold: "#FFD740",
    green: "#69F0AE",
    red: "#FF5252",
    orange: "#FF8A65",
    // Text tones
    white: "#FFFFFF",
    dim: "rgba(244,224,255,0.65)",
    muted: "rgba(244,224,255,0.4)",
    faint: "rgba(244,224,255,0.15)"
};

});

parcelRegister("5jQtK", function(module, exports) {

$parcel$export(module.exports, "COPY", function () { return $3df76f49876985eb$export$92f9e1ed9114d3a6; });

var $6uXpe = parcelRequire("6uXpe");
const $3df76f49876985eb$export$92f9e1ed9114d3a6 = {
    ui: {
        backLink: "\u2190 NorthStar",
        scrollHint: "SCROLL TO EXPLORE \u2193",
        footer: "TELIA \xd7 ERICSSON \xb7 CO-FUNDED BY THE EUROPEAN UNION",
        roadmapTapHint: "Tap a year to explore milestones",
        roadmapMilestones: "NorthStar milestones"
    },
    navLabels: [
        "",
        "Inflection",
        "Three Waves",
        "Innovation Network",
        "Latency Demo",
        "Inside the Core",
        "Live Slicing",
        "AI-Native",
        "Ambient (ISAC)",
        "Positioning",
        "Sky as Network",
        "Verticals 2035",
        "The $1.3T Shift",
        "Vision"
    ],
    hero: {
        kicker: "NorthStar \xb7 2026 \u2192 2036",
        title: "The Next Decade",
        subtitle: [
            "When 5G Standalone stops being ",
            {
                t: "a network",
                c: (0, $6uXpe.P).cyan
            },
            {
                br: true
            },
            "and becomes ",
            {
                t: "the platform of the planet.",
                grad: [
                    (0, $6uXpe.P).magenta,
                    (0, $6uXpe.P).gold
                ]
            }
        ],
        stats: [
            {
                v: 1.3,
                pre: "$",
                suf: "T",
                dec: 1,
                label: "Global 5G value pool by 2035"
            },
            {
                v: 25,
                pre: "",
                suf: "B",
                dec: 0,
                label: "Connected devices on 5G SA"
            },
            {
                v: 10,
                pre: "",
                suf: "\xd7",
                dec: 0,
                label: "Premium-slice ARPU uplift (potential)"
            },
            {
                v: 99.999,
                pre: "",
                suf: "%",
                dec: 3,
                label: "Sovereign-grade reliability"
            }
        ],
        note: "Headline figures are indicative \u2014 blended from public industry forecasts (analyst, GSMA and vendor estimates) and 3GPP targets, not a single audited source."
    },
    inflection: {
        kicker: "The Inflection Point",
        headline: [
            "We are ",
            {
                t: "here.",
                c: (0, $6uXpe.P).gold
            },
            {
                br: true
            },
            {
                t: "And everything is about to change.",
                c: (0, $6uXpe.P).dim,
                size: "0.55em"
            }
        ],
        youAreHere: "2026 \xb7 You are here",
        eras: [
            {
                era: "2G",
                y: "1991",
                t: "Voice",
                c: (0, $6uXpe.P).faint
            },
            {
                era: "3G",
                y: "2001",
                t: "Data",
                c: (0, $6uXpe.P).faint
            },
            {
                era: "4G LTE",
                y: "2009",
                t: "Fast pipes",
                c: (0, $6uXpe.P).muted
            },
            {
                era: "5G NSA",
                y: "2019",
                t: "Faster pipes",
                c: (0, $6uXpe.P).dim
            },
            {
                era: "5G SA",
                y: "2024",
                t: "Programmable",
                c: (0, $6uXpe.P).cyan
            },
            {
                era: "5G-Adv",
                y: "2026",
                t: "Cognitive",
                c: (0, $6uXpe.P).magenta
            },
            {
                era: "6G",
                y: "2030+",
                t: "Ambient",
                c: (0, $6uXpe.P).gold
            }
        ],
        note: [
            "Every prior generation gave us ",
            {
                t: "more bandwidth",
                c: (0, $6uXpe.P).dim,
                b: true
            },
            ". 5G Standalone gives us something fundamentally different: a network that is ",
            {
                t: "cloud-native",
                c: (0, $6uXpe.P).cyan,
                b: true
            },
            ", ",
            {
                t: "sliceable",
                c: (0, $6uXpe.P).magenta,
                b: true
            },
            ", ",
            {
                t: "programmable",
                c: (0, $6uXpe.P).gold,
                b: true
            },
            ", and ready to become ",
            {
                t: "intelligent",
                c: (0, $6uXpe.P).green,
                b: true
            },
            ". The decade ahead is when that potential cashes in."
        ]
    },
    waves: {
        kicker: "How the decade unfolds",
        headline: [
            "Three waves:",
            {
                br: true
            },
            {
                t: "Programmable",
                c: (0, $6uXpe.P).cyan
            },
            " \xb7 ",
            {
                t: "Cognitive",
                c: (0, $6uXpe.P).magenta
            },
            " \xb7 ",
            {
                t: "Ambient",
                c: (0, $6uXpe.P).gold
            }
        ],
        bands: [
            {
                tag: "Wave 1 \xb7 2025\u20132027",
                title: "Programmable",
                icon: "\u2699\uFE0F",
                color: (0, $6uXpe.P).cyan,
                summary: "Network as software. Slices, APIs, edge breakout, on-demand QoS \u2014 the moment connectivity becomes a controllable resource.",
                bullets: [
                    "Network slicing at scale across consumer, enterprise, mission-critical",
                    "CAMARA APIs commercialized \u2014 Quality-on-Demand, Location, Device Status and more",
                    "Edge breakout to multiple nodes distributed across Sweden providing AI compute",
                    "Low Latency, Low Loss, Scalable throughput (L4S) deployed end-to-end with realistic partner workloads"
                ]
            },
            {
                tag: "Wave 2 \xb7 2027\u20132030",
                title: "Cognitive",
                icon: "\uD83E\uDDE0",
                color: (0, $6uXpe.P).magenta,
                summary: "Network as intelligence. AI inside the RAN, the core, the orchestration loop \u2014 predicting, healing, optimizing in real time.",
                bullets: [
                    "Analytics-driven closed-loop assurance \u2014 proactive SLA management",
                    "AI-native RAN: beam management, scheduling, energy adaptation",
                    "Intent-based slice creation \u2014 describe outcomes, network configures itself",
                    "Digital twin of the network for what-if planning and continuous tuning"
                ]
            },
            {
                tag: "Wave 3 \xb7 2030\u20132035+",
                title: "Ambient",
                icon: "\uD83C\uDF0C",
                color: (0, $6uXpe.P).gold,
                summary: "Network as nervous system. The air itself becomes a sensor; the sky becomes a cell; the network becomes the platform of the planet.",
                bullets: [
                    "Integrated Sensing & Communication (ISAC) as a paid service",
                    "Direct-to-device satellite \u2014 seamless terrestrial/NTN handover",
                    "Ambient IoT \u2014 billions of battery-less devices via backscatter",
                    "Post-quantum security & sovereign-grade slicing as default"
                ]
            }
        ]
    },
    innovation: {
        kicker: "The NorthStar Innovation Network",
        headline: [
            "A live ",
            {
                t: "5G SA",
                c: (0, $6uXpe.P).cyan
            },
            " network to prove what's next"
        ],
        body: "NorthStar is a dual 5G SA core running in parallel with Telia's public network \u2014 in a secure Telia site, managed by Ericsson on the latest available 3GPP release software. It's where Telia, Ericsson and partner organizations trial new functionalities, slice configurations, APIs and edge services before they reach the world-wide market years later.",
        pillars: [
            {
                icon: "\uD83E\uDDE0",
                title: "Always the latest 5G SA core functions",
                desc: "Independent dual 5G SA core, always on the latest 3GPP \u2014 dedicated for R&D alongside the live network.",
                c: (0, $6uXpe.P).cyan
            },
            {
                icon: "\uD83D\uDCE1",
                title: "Radio where it's needed",
                desc: "Dedicated or shared public radio at customer sites (RRPs), over Telia's national IP transport.",
                c: (0, $6uXpe.P).magenta
            },
            {
                icon: "\uD83E\uDDE9",
                title: "Slices for real use cases",
                desc: "Use-case slices and 5QIs tied to DNNs \u2014 orchestrated on demand for V2X, drone control, factory automation.",
                c: (0, $6uXpe.P).gold
            },
            {
                icon: "\u26A1",
                title: "Open and intelligent",
                desc: "Distributed regional + local edge nodes for compute, CAMARA APIs, plus Security Manager and Network Locator.",
                c: (0, $6uXpe.P).green
            }
        ]
    },
    demo: {
        kicker: "Live use-case demo \xb7 AstaZero",
        headline: [
            "Low latency for ",
            {
                t: "automotive safety",
                c: (0, $6uXpe.P).cyan
            }
        ],
        body: "At Sweden's AstaZero proving ground, on the NorthStar network: a remotely-driven car turns across traffic while a truck hides a fast-approaching car. A 5G-connected roadside sensor detects the impending collision and signals the car to brake \u2014 the same experiment, run over two network qualities.",
        clips: [
            {
                tag: "Best-effort \xb7 5QI 9",
                outcome: "Latency too high \u2014 the emergency brake signal reaches the car too late, and it is struck.",
                c: (0, $6uXpe.P).red
            },
            {
                tag: "Low-latency V2X \xb7 5QI 79",
                outcome: "Lower latency \u2014 the signal arrives in time; the car brakes to a complete halt, safely.",
                c: (0, $6uXpe.P).green
            }
        ]
    },
    core: {
        kicker: "Architecture \xb7 Preview",
        headline: [
            "Inside the ",
            {
                t: "5G SA Core",
                c: (0, $6uXpe.P).gold
            }
        ],
        body: "Slices, RRPs, 5QIs, DNNs \u2014 the programmable fabric beneath every future use case. Explore the relationships that turn one network into many purpose-built ones."
    },
    slicing: {
        kicker: "Live Simulation",
        headline: [
            "Radio spectrum ",
            {
                t: "used wisely",
                c: (0, $6uXpe.P).cyan
            }
        ],
        body: "Radio resource partitions borrow unused spectrum from one another within policy min/max bounds. When a slice goes idle its floor returns to the shared pool so another can burst toward its ceiling \u2014 and the instant demand returns, the scheduler hands the capacity straight back."
    },
    ainative: {
        kicker: "Wave 2 \xb7 2027\u20132030",
        headline: [
            "The network becomes ",
            {
                t: "cognitive",
                c: (0, $6uXpe.P).magenta
            }
        ],
        body: "Closed-loop assurance powered by NWDAF, digital twins and AI-native RAN. The network observes itself, predicts failures before they happen, applies fixes \u2014 and learns from the result.",
        brainTitle: "AI Brain",
        brainSub: "NWDAF \xb7 DIGITAL TWIN",
        loop: [
            {
                x: 90,
                y: 90,
                label: "OBSERVE",
                sub: "RAN + Core + UE telemetry",
                color: (0, $6uXpe.P).cyan
            },
            {
                x: 430,
                y: 50,
                label: "PREDICT",
                sub: "NWDAF \xb7 ML inference",
                color: (0, $6uXpe.P).magenta
            },
            {
                x: 720,
                y: 110,
                label: "DECIDE",
                sub: "Policy + intent reasoning",
                color: (0, $6uXpe.P).gold
            },
            {
                x: 720,
                y: 330,
                label: "APPLY",
                sub: "Slice / 5QI / beam / power",
                color: (0, $6uXpe.P).green
            },
            {
                x: 430,
                y: 380,
                label: "VERIFY",
                sub: "Real-time SLA evidence",
                color: (0, $6uXpe.P).orange
            },
            {
                x: 90,
                y: 330,
                label: "LEARN",
                sub: "Feedback into the model",
                color: (0, $6uXpe.P).light
            }
        ],
        points: [
            {
                color: (0, $6uXpe.P).cyan,
                title: "Proactive SLA",
                desc: "Predict slice degradation 30+ seconds before users feel it; reschedule resources first."
            },
            {
                color: (0, $6uXpe.P).magenta,
                title: "Intent-Based Slicing",
                desc: 'Describe outcomes ("sub-10ms for 200 robots") \u2014 the orchestrator designs and deploys the slice.'
            },
            {
                color: (0, $6uXpe.P).gold,
                title: "Energy as a Metric",
                desc: "AI tunes radio power, beam selection and sleep cycles for >40% lower energy per Gbit."
            },
            {
                color: (0, $6uXpe.P).green,
                title: "Digital Twin Ops",
                desc: "Run what-if scenarios against a live, continuously-trained twin before touching production."
            }
        ],
        note: [
            {
                t: "NWDAF",
                c: (0, $6uXpe.P).magenta,
                b: true
            },
            " is the 3GPP-defined Network Data Analytics Function for 5G Core, responsible for collecting network data and producing analytics that other network functions can use for AI-based analytics, automation and optimization."
        ]
    },
    ambient: {
        kicker: "Wave 3 \xb7 2030\u20132035",
        headline: [
            "The air itself becomes a ",
            {
                t: "sensor",
                c: (0, $6uXpe.P).gold
            }
        ],
        body: [
            "Integrated Sensing & Communication (ISAC) reuses the same waveform that carries your data to detect drones, vehicles, people, weather \u2014 without cameras, without extra hardware. The network stops being a pipe and becomes ",
            {
                t: "a continuous, ambient sense",
                c: (0, $6uXpe.P).gold,
                b: true
            },
            " of the physical world."
        ],
        gnbLabel: "gNB \xb7 ISAC",
        targets: [
            {
                x: 28,
                y: 30,
                label: "Drone",
                color: (0, $6uXpe.P).cyan
            },
            {
                x: 72,
                y: 22,
                label: "Vehicle",
                color: (0, $6uXpe.P).gold
            },
            {
                x: 80,
                y: 60,
                label: "Person",
                color: (0, $6uXpe.P).green
            },
            {
                x: 22,
                y: 72,
                label: "Weather",
                color: (0, $6uXpe.P).magenta
            },
            {
                x: 60,
                y: 80,
                label: "Asset",
                color: (0, $6uXpe.P).light
            }
        ],
        uses: [
            {
                icon: "\uD83D\uDEF8",
                title: "Drone airspace mapping",
                desc: "Track tens of thousands of UAVs in real time for low-altitude traffic management."
            },
            {
                icon: "\uD83C\uDF27\uFE0F",
                title: "Weather & atmospheric sensing",
                desc: "Detect rain cells, fog and pollution at street resolution \u2014 for cities, ports and farming."
            },
            {
                icon: "\uD83D\uDEB7",
                title: "Privacy-respecting presence",
                desc: "Count and track without cameras: factories, hospitals, transport hubs."
            },
            {
                icon: "\uD83D\uDEE1\uFE0F",
                title: "Defence-grade situational awareness",
                desc: "Sovereign sensing slice for armed forces & critical infrastructure."
            },
            {
                icon: "\uD83D\uDCB8",
                title: "Sensing-as-a-Service",
                desc: "A new revenue stream measured in queries-per-day, not Gbits."
            }
        ]
    },
    positioning: {
        kicker: "Positioning Revolution",
        headline: [
            "From ",
            {
                t: "cell-ID guesses",
                c: (0, $6uXpe.P).muted
            },
            " to ",
            {
                t: "centimetres",
                c: (0, $6uXpe.P).green
            }
        ],
        body: "5G SA positioning fuses RAN measurements, RTK, AI inference and ISAC to deliver indoor + outdoor accuracy that GNSS-only systems can't touch.",
        ladder: [
            {
                era: "5G SA \xb7 2026\u20132027",
                acc: "~1\u20132 m",
                detail: "Indoor \u2014 dot positioning \xb7 RTK over 5G SA",
                color: (0, $6uXpe.P).cyan
            },
            {
                era: "5G SA \xb7 2026\u20132027",
                acc: "<50 m",
                detail: "Outdoor \u2014 Timing Advance + Angle-of-Arrival \xb7 GPS-level alternative / fallback",
                color: (0, $6uXpe.P).cyan
            },
            {
                era: "2028\u20132030",
                acc: "<1 m",
                detail: "AI fusion \xb7 ISAC \xb7 macro",
                color: (0, $6uXpe.P).magenta
            },
            {
                era: "2030+",
                acc: "<10 cm",
                detail: "Cross-tech \xb7 6G upper mid",
                color: (0, $6uXpe.P).green
            }
        ],
        examplesTitle: "Use cases \u2014 across every era",
        examples: [
            {
                icon: "\u26CF\uFE0F",
                what: "Underground tracking of workers and machines far below the surface."
            },
            {
                icon: "\uD83E\uDDBD",
                what: "Locate medical assets in hospitals to the room \u2014 without GPS."
            },
            {
                icon: "\uD83D\uDE9B",
                what: "Lane-level vehicle positioning for autonomous corridors."
            }
        ]
    },
    ntn: {
        kicker: "Non-Terrestrial Networks",
        headline: [
            "The sky becomes part of ",
            {
                t: "the cell plan",
                c: (0, $6uXpe.P).cyan
            }
        ],
        body: "Satellite and terrestrial converge into one fabric. Phones connect direct-to-satellite as easily as to a tower. Backhaul, IoT and emergency comms span deep mines to open oceans \u2014 with no dead zones.",
        items: [
            {
                y: "Now",
                title: "Satellite as backhaul",
                desc: "NorthStar explores LEO/MEO backhaul for nomadic & rural cells.",
                c: (0, $6uXpe.P).cyan
            },
            {
                y: "2027",
                title: "NR-NTN normative",
                desc: "First handover-capable satellite 5G NR; IoT-NTN store-and-forward.",
                c: (0, $6uXpe.P).magenta
            },
            {
                y: "2029\u201330",
                title: "Direct-to-device handsets",
                desc: "Consumer phones speaking 5G to LEO sats \u2014 seamless terrestrial fallback.",
                c: (0, $6uXpe.P).gold
            },
            {
                y: "2031+",
                title: "Regenerative payloads & 6G NTN",
                desc: "Full convergence: one core, many access types \u2014 aeronautical & maritime.",
                c: (0, $6uXpe.P).green
            }
        ],
        note: [
            {
                t: "Regenerative payloads",
                c: (0, $6uXpe.P).green,
                b: true
            },
            " process the radio signal on board the satellite \u2014 demodulating and re-modulating it rather than just amplifying and forwarding it (a transparent 'bent-pipe' relay) \u2014 effectively putting the gNodeB in orbit, enabling inter-satellite routing and lower latency."
        ]
    },
    verticals: {
        kicker: "Verticals in 2035",
        headline: [
            "What becomes ",
            {
                t: "ordinary",
                c: (0, $6uXpe.P).magenta
            }
        ],
        body: "Each industry rebuilt on top of slicing, edge, ISAC, NTN and AI-native operations.",
        cards: [
            {
                icon: "\u26CF\uFE0F",
                year: "2030",
                title: "Mining without humans underground",
                color: (0, $6uXpe.P).cyan,
                body: "Autonomous fleets coordinated by URLLC + cm-level positioning, supervised from surface \u2014 operations 24/7 without endangering people.",
                tech: "URLLC \xb7 5G SA Positioning \xb7 Edge AI"
            },
            {
                icon: "\uD83D\uDE91",
                year: "2028",
                title: "The ambulance becomes the hospital",
                color: (0, $6uXpe.P).red,
                body: "4K live video + ECG/ultrasound stream over dedicated slice. Hospital clinicians treat patients before arrival.",
                tech: "URLLC + eMBB \xb7 Slicing \xb7 Edge"
            },
            {
                icon: "\uD83D\uDE97",
                year: "2033",
                title: "Autonomous corridors at scale",
                color: (0, $6uXpe.P).gold,
                body: "V2X sub-ms safety messages, edge handover between road segments, cooperative driving \u2014 Sweden's first nationwide corridor by 2033.",
                tech: "V2X \xb7 TSN \xb7 MEC \xb7 5QI 86"
            },
            {
                icon: "\uD83C\uDFED",
                year: "2031",
                title: "Lights-out factories",
                color: (0, $6uXpe.P).green,
                body: "TSN over 5G LAN replaces wired Ethernet; robots, AGVs and PLCs share a single deterministic wireless fabric.",
                tech: "TSN \xb7 URLLC \xb7 5G LAN \xb7 5QI 83"
            },
            {
                icon: "\uD83D\uDEE1\uFE0F",
                year: "2030",
                title: "Sovereign mission-critical",
                color: (0, $6uXpe.P).purple,
                body: "Defence and emergency services run on dedicated slices with pre-emptive priority and assured availability.",
                tech: "Sovereign slice \xb7 MCX \xb7 Sensing"
            },
            {
                icon: "\u26A1",
                year: "2032",
                title: "Smart grids that self-balance",
                color: (0, $6uXpe.P).magenta,
                body: "Substations exchange synchronisation and load data within microseconds; demand response in real time.",
                tech: "TSN over 5G \xb7 1588 PTP \xb7 Edge"
            },
            {
                icon: "\uD83C\uDF3E",
                year: "2030",
                title: "Precision agriculture at field scale",
                color: (0, $6uXpe.P).electric,
                body: "Tens of thousands of soil/livestock sensors per km\xb2 over RedCap/Ambient IoT; drones via NTN where there's no coverage.",
                tech: "RedCap \xb7 mMTC \xb7 NTN \xb7 Sensing"
            },
            {
                icon: "\uD83C\uDFAE",
                year: "2032",
                title: "Edge-rendered XR everywhere",
                color: (0, $6uXpe.P).gold,
                body: "AR glasses with no on-device GPU; rendering runs 8 ms away at the city edge.",
                tech: "eMBB \xb7 MEC \xb7 5QI 80"
            },
            {
                icon: "\uD83D\uDEF0\uFE0F",
                year: "2031",
                title: "Maritime, polar, aeronautical",
                color: (0, $6uXpe.P).green,
                body: "One 5G subscription works on tankers, planes and Arctic stations via integrated NTN. No more dead zones.",
                tech: "NR-NTN \xb7 Direct-to-Device \xb7 Slicing"
            }
        ]
    },
    economy: {
        kicker: "The Business Model Shift",
        headline: [
            "From ",
            {
                t: "pipes",
                c: (0, $6uXpe.P).muted
            },
            " to ",
            {
                t: "platforms",
                c: (0, $6uXpe.P).cyan
            },
            " to ",
            {
                t: "experiences",
                c: (0, $6uXpe.P).gold
            }
        ],
        body: "The traditional way of pricing data is evolving \u2014 from selling gigabytes to exposing network capabilities and APIs. Customers increasingly pay for outcomes: real-time intelligence and guaranteed capabilities like ultra-reliable low latency. So connectivity revenue flattens as it commoditises, while the new value pool \u2014 slices, exposed APIs and sensing \u2014 grows faster every year of the decade.",
        caption: "Illustrative trajectory. Connectivity ARPU flattens as commoditisation accelerates; new value moves to slices, exposed APIs and sensing services.",
        legend: [
            {
                color: (0, $6uXpe.P).faint,
                label: "Connectivity (commoditising)"
            },
            {
                color: (0, $6uXpe.P).cyan,
                label: "Slices"
            },
            {
                color: (0, $6uXpe.P).magenta,
                label: "APIs (CAMARA)"
            },
            {
                color: (0, $6uXpe.P).gold,
                label: "Sensing-as-a-Service"
            }
        ],
        chart: {
            years: [
                "2025",
                "2027",
                "2029",
                "2031",
                "2033",
                "2035"
            ],
            connectivity: [
                100,
                108,
                112,
                115,
                116,
                116
            ],
            slices: [
                4,
                18,
                36,
                62,
                90,
                118
            ],
            apis: [
                1,
                6,
                22,
                56,
                108,
                168
            ],
            sensing: [
                0,
                1,
                5,
                18,
                44,
                84
            ],
            axisMax: 200
        },
        stats: [
            {
                v: "+10\u201325%",
                l: "Consumer premium ARPU uplift",
                c: (0, $6uXpe.P).dim
            },
            {
                v: "$200\u2013500B",
                l: "Enterprise slice TAM by 2030",
                c: (0, $6uXpe.P).cyan
            },
            {
                v: "$150B+",
                l: "Network API economy (CAMARA)",
                c: (0, $6uXpe.P).magenta
            },
            {
                v: "$10\u201380B",
                l: "Sensing-as-a-Service by 2035 (emerging)",
                c: (0, $6uXpe.P).gold
            }
        ],
        note: "Illustrative figures \u2014 directional analyst/industry forecasts (enterprise-5G, network-API and sensing estimates), not audited."
    },
    roadmap: {
        kicker: "NorthStar Roadmap \xb7 2025\u20132029",
        headline: [
            "Where Sweden builds the ",
            {
                t: "future, first",
                c: (0, $6uXpe.P).cyan
            }
        ],
        cats: [
            {
                id: "qos",
                label: "QoS & Slicing",
                icon: "\u2699\uFE0F"
            },
            {
                id: "apis",
                label: "Network APIs",
                icon: "\uD83D\uDD0C"
            },
            {
                id: "location",
                label: "Positioning",
                icon: "\uD83D\uDCCD"
            },
            {
                id: "edge",
                label: "Edge & AI",
                icon: "\u2601\uFE0F"
            },
            {
                id: "iot",
                label: "RedCap / IoT",
                icon: "\uD83D\uDCF6"
            },
            {
                id: "uplink",
                label: "Uplink Boost",
                icon: "\uD83D\uDCE1"
            },
            {
                id: "v2x",
                label: "V2X",
                icon: "\uD83D\uDE97"
            },
            {
                id: "latency",
                label: "Low Latency / TSN",
                icon: "\u26A1"
            },
            {
                id: "other",
                label: "Sensing & NTN",
                icon: "\uD83D\uDEF0\uFE0F"
            }
        ],
        yearColors: {
            "2025": (0, $6uXpe.P).light,
            "2026": (0, $6uXpe.P).magenta,
            "2027": (0, $6uXpe.P).cyan,
            "2028": (0, $6uXpe.P).purple,
            "2029": (0, $6uXpe.P).gold
        },
        data: {
            "2025": {
                qos: [
                    "Basic slice/DNN/5QI service modelling"
                ],
                apis: [
                    "Telia API Gateway integration",
                    "CAMARA Quality-on-Demand API",
                    "CAMARA Positioning & tracking API"
                ],
                location: [
                    "Indoor dot positioning ~1\u20132 m",
                    "GNSS RTK over 5G SA \u2014 cm-level precision"
                ],
                edge: [
                    "Local & city-wide breakout deployment"
                ],
                iot: [
                    "RedCap for higher throughput at lower battery"
                ],
                uplink: [
                    "UL CA + UL SU-MIMO (3tx)"
                ],
                v2x: [
                    "V2X slice using 5QI 79"
                ],
                latency: [
                    "Introduction of L4S for stable low-latency streams"
                ],
                other: [
                    "SIB9 for 5G time sync"
                ]
            },
            "2026": {
                qos: [
                    "Advanced Slice/DNN/5QI service modelling"
                ],
                apis: [
                    "Geofencing CAMARA via ENL"
                ],
                location: [
                    "AI model for indoor positioning",
                    "Outdoor positioning TA & AoA (~10\u201350 m)",
                    "Passive 5G SA outdoor positioning"
                ],
                edge: [
                    "AI compute edge node integration",
                    "More multi-tenant edge breakout nodes"
                ],
                iot: [
                    "DRX/eDRX power saving for RedCap"
                ],
                uplink: [
                    "Uplink configured grant"
                ],
                v2x: [
                    "Connected digital traffic signage",
                    "Additional 5QIs for V2X"
                ],
                latency: [
                    "L4S E2E usage by first NorthStar partners"
                ],
                other: [
                    "ISAC/Sensing testing at Future by Lund",
                    "Satellite as backhaul exploration"
                ]
            },
            "2027": {
                qos: [
                    "New templates for 5GAA & 5G-ACIA",
                    "URSP for Windows/iOS/Android"
                ],
                apis: [
                    "Seamless authentication via CAMARA + SES",
                    "Connectivity insights via CAMARA"
                ],
                location: [
                    "Improved indoor positioning through AI",
                    "Macro positioning tuned & more precise"
                ],
                edge: [
                    "Rollout of distributed AI+Edge nodes",
                    "Scaling edge breakout to 40+ city nodes"
                ],
                iot: [
                    "eRedCap for ultra-optimised battery"
                ],
                uplink: [
                    "Local mmWave (regulator dependent)"
                ],
                v2x: [
                    "Edge discovery / handover for vehicles"
                ],
                latency: [
                    "L4S rollout to several partners",
                    "uRLLC enhancements (RAN)"
                ],
                other: [
                    "Early sensing + tracking ISAC scenarios",
                    "Satellite as backhaul deployment",
                    "Nomadic cells for underserved areas"
                ]
            },
            "2028": {
                qos: [
                    "Intent-based slice creation incl. QoS"
                ],
                apis: [
                    "CAMARA network slice booking",
                    "Connectivity insights via CAMARA"
                ],
                location: [
                    "High-accuracy cross-tech positioning (macro \u2194 indoor \u2194 RTK)",
                    "Improved positioning using ISAC"
                ],
                edge: [
                    "Edge breakout scaling to 100+ city nodes"
                ],
                iot: [
                    "RedCap and eRedCap device proliferation"
                ],
                uplink: [
                    "Expanded mmWave (regulator dependent)"
                ],
                v2x: [
                    "Remote control of vehicles in public-road trials"
                ],
                latency: [
                    "TSN for manufacturing & smart grids (5G LAN)",
                    "Latency-prioritised scheduling for TSN"
                ],
                other: [
                    "ISAC deployed for public sector & defence",
                    "NR-NTN & IoT-NTN early deployment"
                ]
            },
            "2029": {
                qos: [
                    "AI-based slice creation incl. QoS"
                ],
                apis: [
                    "Support for 20+ CAMARA APIs"
                ],
                location: [
                    "Mature positioning using ISAC",
                    "Leaking-cable positioning exploration"
                ],
                edge: [
                    "Full NorthStar integration across AI + Edge + RAN"
                ],
                iot: [],
                uplink: [],
                v2x: [
                    "Autonomous-vehicle corridor tests"
                ],
                latency: [
                    "Mature TSN ecosystem"
                ],
                other: [
                    "Mature ISAC ecosystem",
                    "Vertical 5G for aeronautics",
                    "Full 5G/Satellite integration"
                ]
            }
        }
    },
    sixg: {
        kicker: "3GPP Standards \xb7 2024 \u2192 2035",
        headline: [
            "The bridge from ",
            {
                t: "5G-Advanced",
                c: (0, $6uXpe.P).cyan
            },
            " to ",
            {
                t: "6G",
                c: (0, $6uXpe.P).gold
            }
        ],
        body: "Every release lays a brick. By Rel-21, 6G is specified. By Rel-22+, it's commercial. Investing in 5G SA today buys the architectural runway for everything that follows.",
        items: [
            {
                rel: "Rel-18",
                period: "2024",
                label: "5G-Advanced",
                color: (0, $6uXpe.P).cyan,
                bullets: [
                    "AI/ML for RAN",
                    "NTN Phase 2",
                    "XR support",
                    "MBS efficient delivery"
                ]
            },
            {
                rel: "Rel-19",
                period: "2025\u201326",
                label: "5G-Adv. Phase 2",
                color: (0, $6uXpe.P).magenta,
                bullets: [
                    "AI/ML on the air interface",
                    "NTN Phase 3",
                    "ISAC channel modelling",
                    "Ambient IoT"
                ]
            },
            {
                rel: "Rel-20",
                period: "2027\u201328",
                label: "Bridge to 6G",
                color: (0, $6uXpe.P).gold,
                bullets: [
                    "6G study items kick off",
                    "NTN/terrestrial convergence",
                    "Sub-THz exploration",
                    "FR3 (7\u201324 GHz)"
                ]
            },
            {
                rel: "Rel-21",
                period: "2029\u201330",
                label: "6G Specifications",
                color: (0, $6uXpe.P).green,
                bullets: [
                    "6G RAN specs",
                    "AI-native architecture",
                    "Post-quantum migration",
                    "ITU IMT-2030"
                ]
            },
            {
                rel: "Rel-22+",
                period: "2031\u201335",
                label: "6G Commercial",
                color: (0, $6uXpe.P).light,
                bullets: [
                    "Holographic communication",
                    "Sensing as a network service",
                    "Sovereign sub-net slicing",
                    "Energy-efficiency SLAs"
                ]
            }
        ],
        note: {
            label: "\u26A0 IMPLEMENTATION REALITY:",
            text: " Standards take 1\u20133 years for vendors to implement and another 2\u20134 years for operators to integrate (BSS + OSS). Operators that invest in 5G SA now will have a 5-year head-start on the 6G era."
        }
    },
    vision: {
        kicker: "2036",
        headline: [
            "The network won't be",
            {
                br: true
            },
            {
                t: "something you connect to.",
                c: (0, $6uXpe.P).dim
            },
            {
                br: true
            },
            {
                br: true
            },
            {
                t: "It will be everywhere you are.",
                grad: [
                    (0, $6uXpe.P).cyan,
                    (0, $6uXpe.P).light,
                    (0, $6uXpe.P).magenta,
                    (0, $6uXpe.P).gold
                ],
                anim: true
            }
        ],
        body: "Sensing the world. Healing itself. Carrying intent, not just packets. Stretching from underground mines to low orbit. That's the network NorthStar is building \u2014 and the decade in which it arrives.",
        ctas: [
            {
                label: "Back to start \u2192",
                href: "index.html",
                primary: true
            },
            {
                label: "Open the simulations",
                href: "unified-5g-viz.html"
            },
            {
                label: "Talk to us",
                href: "mailto:northstar@teliacompany.com?subject=NorthStar%20Future%20Vision"
            }
        ]
    }
};

});


//# sourceMappingURL=northstar-future-vision.cc6dd712.js.map
